import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { Loader2, ArrowLeft, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email });
      // Toujours message générique : on ne révèle jamais si l'e-mail existe
      const msg = res?.data?.message || "Si cette adresse est associée à un compte, un e-mail de réinitialisation a été envoyé.";
      toast.success(msg);
      setSent(true);
    } catch (error) {
      const status = error.response?.status;
      if (status === 429) {
        toast.error("Trop de demandes. Réessayez dans quelques minutes.");
      } else {
        // Même en cas d'erreur backend, on garde un message neutre côté utilisateur.
        toast.success("Si cette adresse est associée à un compte, un e-mail de réinitialisation a été envoyé.");
        setSent(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary flex items-center justify-center pt-20 px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="bg-white p-8 md:p-12 border border-border">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-3xl font-bold text-primary">ITERCATUS</span>
            </Link>
            <p className="text-xs text-muted-foreground italic mb-4">Le voyage intelligent</p>
            <h1 className="font-heading text-2xl font-bold text-primary">
              Mot de passe oublié
            </h1>
            <p className="text-muted-foreground mt-2">
              Recevez un lien de réinitialisation par e-mail.
            </p>
          </div>

          {sent ? (
            <div className="space-y-6 text-center">
              <div className="mx-auto w-14 h-14 rounded-full bg-emerald-50 flex items-center justify-center">
                <Mail className="h-7 w-7 text-emerald-600" />
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Si cette adresse est associée à un compte, vous recevrez un e-mail
                contenant un lien pour réinitialiser votre mot de passe.
                Ce lien est valable pendant 1 heure et à usage unique.
              </p>
              <Link
                to="/connexion"
                className="inline-flex items-center gap-2 text-accent hover:underline"
                data-testid="back-to-login-link"
              >
                <ArrowLeft className="h-4 w-4" /> Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-primary mb-2">Email</label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.com"
                  required
                  className="h-12"
                  data-testid="forgot-email-input"
                />
              </div>

              <Button
                type="submit"
                className="w-full btn-primary h-12"
                disabled={loading}
                data-testid="forgot-submit-btn"
              >
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Envoi...
                  </>
                ) : (
                  "Envoyer le lien"
                )}
              </Button>

              <div className="text-center">
                <Link to="/connexion" className="text-sm text-accent hover:underline inline-flex items-center gap-1">
                  <ArrowLeft className="h-3 w-3" /> Retour à la connexion
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
